import React from 'react'
import { /*toast as toastify,*/ ToastContainer } from 'react-toastify'
import '../../../node_modules/react-toastify/dist/ReactToastify.css'
//https://www.npmjs.com/package/react-toastify

//import { Offline } from 'react-detect-offline'
//https://www.npmjs.com/package/react-detect-offline

import { ToastStyle } from './styled'

export class Toast extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      autoClose: 3000,
    }
  }

  // internet = {
  //   onChange: (isOnline) => {
  //     if (!isOnline) {
  //       this.setState(
  //         {
  //           autoClose: false,
  //         },
  //         toast.error(MESSAGE.ERROR.INTERNET)
  //       )
  //     } else {
  //       toastify.dismiss()
  //       this.setState({
  //         autoClose: 5000,
  //       })
  //     }
  //   },
  // }

  render() {
    const { autoClose } = this.state
    return (
      <ToastStyle>
        {/* <Offline
          onChange={(e) => {
            this.internet.onChange(e)
          }}
        /> */}
        <ToastContainer
          hideProgressBar
          preventDuplicated
          position="top-center"
          closeButton={false}
          autoClose={autoClose}
          {...this.props}
          limit={1}
          closeOnClick={true}
        />
      </ToastStyle>
    )
  }
}
